module.exports = __webpack_public_path__ + "img/oneOrange.5455e9ed.jpg";